import { default as BaseIconButton } from '@mui/joy/IconButton';
import ButtonGroupContext from '@mui/joy/ButtonGroup/ButtonGroupContext';
import { forwardRef, useContext, type JSX } from 'react';
import clsx from 'clsx';
import type { ToggleButtonGroupSizes } from '../../types';
import type { ToggleGroupIconButtonProps } from './types';
import { getButtonGroupIconButtonClassName } from './styles';
import { buttonGroupIconSizeMap } from './utils';

const ToggleGroupIconButton = forwardRef<HTMLButtonElement, ToggleGroupIconButtonProps>(
  (props, ref): JSX.Element => {
    const {
      size: sizeProp,
      className,
      Icon,
      selected,
      slotProps,
      color = 'neutral',
      disabled = false,
      ...rest
    } = props;
    const buttonGroup = useContext(ButtonGroupContext);

    const size: ToggleButtonGroupSizes = sizeProp ?? buttonGroup.size ?? 'md';

    const iconSize = buttonGroupIconSizeMap[size];

    const iconButtonClassName = getButtonGroupIconButtonClassName({
      className,
      size,
      selected,
      color,
      disabled,
    });
    const textClassName =
      (selected
        ? slotProps?.toggleButton.selectedClassName
        : slotProps?.toggleButton.unSelectedClassName) ?? '';

    return (
      <BaseIconButton
        disabled={disabled}
        ref={ref}
        {...rest}
        className={clsx(iconButtonClassName, textClassName)}
      >
        <Icon height={iconSize} width={iconSize} />
      </BaseIconButton>
    );
  },
);

ToggleGroupIconButton.displayName = 'ButtonGroupIconButton';

export default ToggleGroupIconButton;
